import config from "../../config";

const AI_MAINFRAME_HOST = config.aiMainframeHost || "";
if (!AI_MAINFRAME_HOST) {
  console.error("REACT_APP_AI_MAINFRAME_HOST is not set — ai-mainframe API calls will fail");
}

function jsonHeaders(token) {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

async function handleResponse(response) {
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const message = body.message || body.error || `HTTP error ${response.status}`;
    const err = new Error(message);
    err.status = response.status;
    err.body = body;
    throw err;
  }
  return response.json();
}

export async function generateMessage(token, { sentimentAnalysisId, actionCategory, context }) {
  const response = await fetch(`${AI_MAINFRAME_HOST}/api/application-support-agent/generate-message`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify({
      sentiment_analysis_id: sentimentAnalysisId,
      action_category: actionCategory,
      context,
    }),
  });
  return handleResponse(response);
}

export async function executeAction(token, { actionToken, actionCategory, message }) {
  const response = await fetch(`${AI_MAINFRAME_HOST}/api/application-support-agent/execute-action`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify({
      action_token: actionToken,
      action_category: actionCategory,
      message,
    }),
  });
  return handleResponse(response);
}

export async function acceptProposal(token, { actionToken }) {
  const response = await fetch(`${AI_MAINFRAME_HOST}/api/application-support-agent/accept-proposal`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify({
      action_token: actionToken,
    }),
  });
  return handleResponse(response);
}

export async function dismissAction(token, { actionToken, actionDescription }) {
  const response = await fetch(`${AI_MAINFRAME_HOST}/api/application-support-agent/dismiss`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify({
      action_token: actionToken,
      action_description: actionDescription,
    }),
  });
  return handleResponse(response);
}

export async function refreshProposal(token, { alertId }) {
  const response = await fetch(
    `${AI_MAINFRAME_HOST}/api/application-support-agent/refresh-proposal`,
    {
      method: "POST",
      headers: jsonHeaders(token),
      body: JSON.stringify({ alert_id: alertId }),
    },
  );
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const message = body.message || body.error || `HTTP error ${response.status}`;
    const err = new Error(message);
    err.status = response.status;
    err.body = body;
    throw err;
  }
}
